/* RESPONSIBLE TEAM: team-inbox */
import Model, { attr, hasMany } from '@ember-data/model';

export default class DomainObjectType extends Model {
  @attr() name;
  @hasMany('conversation-attributes/descriptor', { async: false }) descriptors;
}
